export const DocDivisionType = Object.freeze({
  DOWNLOAD: "DOWNLOAD",
  TECHNICAL_ARTICLE: "TECHNICAL_ARTICLE",
  EDUCATION_ARTICLE: "EDUCATION_ARTICLE",
  QNA: "QNA",
  BLOG: "BLOG",
  BOARD: "BOARD",
  SAMPLE: "SAMPLE",
  SW_SERVICE: "SW_SERVICE",
  RND_NOTI: "RND_NOTI",
  RND_TALK: "RND_TALK",
  RND_QNA: "RND_QNA",
  PARTNER_QNA: "PARTNER_QNA",
  PARTNER_NOTI: "PARTNER_NOTI"
});

